var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroCloseBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.914,
    height: 23.914,
    viewBox: "0 0 23.914 23.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "comment-slash",
    d: "M23,21.586V12A11,11,0,0,0,4.963,3.549L1.457.043.043,1.457l22.5,22.5,1.414-1.414L23,21.586ZM12,3a9.01,9.01,0,0,1,9,9v7.586L6.385,4.971A8.934,8.934,0,0,1,12,3Zm4.758,18,2,2H12A10.995,10.995,0,0,1,2.4,6.64L3.883,8.125A8.989,8.989,0,0,0,12,21h4.758Z",
    transform: "translate(-0.043 -0.043)",
    fill: "#f33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroCloseBtn);
export default __webpack_public_path__ + "static/media/Asset-KuroCloseBtn.d7a94d74c1b0bc910776d3fc1732d6f1.svg";
export { ForwardRef as ReactComponent };